import VanillaCalendar from '@uvarov.frontend/vanilla-calendar';

// CSS Selector
if(document.querySelectorAll('.act-post-calendar').length){
  const calendar = new VanillaCalendar('.act-post-calendar', {
    // Options
    type: 'default',
    date: {
      min: '2020-01-01',
      max: '2100-12-31',
      today: new Date()
    },
    settings: {
      lang: 'define',
      visibility: {
        weekend: false,
        today: false,
      },
      selection: {
        day: false
      }
    },
    locale: {
      months: actPostCalendarMonths ? actPostCalendarMonths : null,
      weekday: actPostCalendarWeekdays ? actPostCalendarWeekdays : null
    },
    popups: actPostCalendarPopups ? actPostCalendarPopups : null
  });
  calendar.init();
}
